import React, { useEffect, useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Row } from 'primereact/row';
import { ColumnGroup } from 'primereact/columngroup'
import './summary.css'
import axios from 'axios';
import { Api } from '../../../services/api';
import { InputNumber } from 'primereact/inputnumber';
import { Toast } from 'primereact/toast'
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';
import { BsFillInfoCircleFill } from 'react-icons/bs';


const Summary = () => {
  const toast = useRef(null);
  const [projectionSummary, setProjectionSummary] = useState([]);
  const [ColumnName, setColumnName] = useState([]);
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    console.log('Fetching projects...');
    getProjectionSummary();

  }, []);

  const getProjectionSummary = async () => {

    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
    axios.get(Api.API_BASE_URL + 'get-financial-summary', { headers })
      .then((response) => {
        setIsLoading(false);
        setProjectionSummary(response.data.result);

        setColumnName(response.data.ColumnName)
      })
      .catch((error) => {
        // stop loader
        setIsLoading(false);
        console.error('Error fetching projects:', error);
      });
  }

  const headerGroup = (
    <ColumnGroup>
      <Row>
        {/* First Column (Frozen) */}
        <Column 
          field={ColumnName[0]} 
          frozen 
          header={ColumnName[0]} 
          style={{ 
            width: '300px', 
            textAlign: 'left', 
            // padding: '8px', 
            height: '40px',
            // borderBottom: '1px solid gray', 
            // borderRight: '1px solid gray' 
          }} 
        />
  
        {/* Remaining Columns */}
        {ColumnName.slice(1).map((row, i) => (
          <Column 
            key={i + 1} 
            header={row}
            style={{ 
              textAlign: 'center', 
              width: '150px', 
              // padding: '8px', 
              height: '40px',
              // backgroundColor: row === "Year" || row === "% of Sales" ? '#FFC000' : '#F8F9FA', 
              // borderBottom: '1px solid gray', 
              // borderRight: '1px solid gray' 
            }} 
          />
        ))}
      </Row>
    </ColumnGroup>
  );

  const goalFieldByLabel = {
    income: 'gross_sales',
    totalincome: 'gross_sales',
    grosssales: 'gross_sales',
    grossprofitpercent: 'gross_profit',
    grossprofit: 'gross_profit',
    operatingexpenses: 'less_total_operating_expense',
    operatingexpensespercent: 'less_total_operating_expense',
    operatingexpensesofsales: 'less_total_operating_expense',
    lesstotaloperatingexpense: 'less_total_operating_expense',
    ofsales: 'less_total_operating_expense',
    lidamultifamilyprojects: 'multi_family',
    lidamultifamilyprojectsofrevenue: 'multi_family_revenue',
    customhomesprojects: 'custom_home',
    customhomesprojectsofrevenue: 'custom_home_revenue',
    renovationsprojects: 'renovations',
    renovationsprojectsofrevenue: 'renovations_revenue',
    commercialprojects: 'commercial',
    commercialprojectsofrevenue: 'commercial_revenue',
    tenentimprovementsprojects: 'tenent_improvements',
    tenantimprovementsprojects: 'tenent_improvements',
    tenentimprovementprojectsofrevenue: 'tenent_improvements_revenue',
    tenantimprovementprojectsofrevenue: 'tenent_improvements_revenue',
    servicemaintenanceprojects: 'service_and_maintenance',
    servicemaintenanceprojectsofrevenue: 'service_and_maintenance_revenue'
  };

  const goalDefaults = {
    gross_sales: 0,
    gross_profit: 0,
    less_total_operating_expense: 0,
    multi_family: 0,
    multi_family_revenue: 0,
    custom_home: 0,
    custom_home_revenue: 0,
    renovations: 0,
    renovations_revenue: 0,
    commercial: 0,
    commercial_revenue: 0,
    tenent_improvements: 0,
    tenent_improvements_revenue: 0,
    service_and_maintenance: 0,
    service_and_maintenance_revenue: 0
  };

  const getAuthHeaders = () => {
    const token = localStorage.getItem('authToken');
    return {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
  };

  const normalizeText = (value) => (value || '').toString().toLowerCase().replace(/[^a-z0-9]/g, '');

  const coerceNumber = (value) => {
    if (value === null || value === undefined || value === '') {
      return 0;
    }
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : 0;
    }
    const normalized = value.toString().replace(/[$,%\s,]/g, '');
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const getYearFromColumn = (columnField) => {
    const match = (columnField || '').toString().match(/(20\d{2})/);
    return match ? match[1] : null;
  };

  const getGoalFieldFromRow = (rowData) => {
    const firstColumnName = ColumnName[0] || 'Sales';
    const label = rowData?.[firstColumnName] || rowData?.Sales || '';
    const normalizedLabel = normalizeText(label);

    if (goalFieldByLabel[normalizedLabel]) {
      return goalFieldByLabel[normalizedLabel];
    }

    if (normalizedLabel === 'income' || normalizedLabel.includes('totalincome')) return 'gross_sales';
    if (normalizedLabel.includes('grosssales')) return 'gross_sales';
    if (normalizedLabel.includes('grossprofit')) return 'gross_profit';
    if (normalizedLabel.includes('operatingexpense')) return 'less_total_operating_expense';
    if (normalizedLabel.includes('lesstotaloperatingexpense')) return 'less_total_operating_expense';
    if (normalizedLabel.includes('multifamily') && normalizedLabel.includes('revenue')) return 'multi_family_revenue';
    if (normalizedLabel.includes('multifamily')) return 'multi_family';
    if (normalizedLabel.includes('customhome') && normalizedLabel.includes('revenue')) return 'custom_home_revenue';
    if (normalizedLabel.includes('customhome')) return 'custom_home';
    if (normalizedLabel.includes('renovation') && normalizedLabel.includes('revenue')) return 'renovations_revenue';
    if (normalizedLabel.includes('renovation')) return 'renovations';
    if (normalizedLabel.includes('commercial') && normalizedLabel.includes('revenue')) return 'commercial_revenue';
    if (normalizedLabel.includes('commercial')) return 'commercial';
    if ((normalizedLabel.includes('tenentimprovement') || normalizedLabel.includes('tenantimprovement')) && normalizedLabel.includes('revenue')) return 'tenent_improvements_revenue';
    if (normalizedLabel.includes('tenentimprovement') || normalizedLabel.includes('tenantimprovement')) return 'tenent_improvements';
    if (normalizedLabel.includes('servicemaintenance') && normalizedLabel.includes('revenue')) return 'service_and_maintenance_revenue';
    if (normalizedLabel.includes('servicemaintenance')) return 'service_and_maintenance';

    return null;
  };

  const isEditableGoalCell = (rowData, field) => {
    if (!field || field === ColumnName[0]) {
      return false;
    }
    return !!getYearFromColumn(field) && !!getGoalFieldFromRow(rowData);
  };

  const fetchGoalForYear = async (year) => {
    const response = await fetch(Api.API_BASE_URL + 'get-goal', {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ year })
    });
    return response.json();
  };

  const saveGoalPayload = async (payload) => {
    const response = await fetch(Api.API_BASE_URL + 'save-goal', {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(payload)
    });
    return response.json();
  };
  const renderDecimalCell = (rowData, column) => {

    const value = rowData[column.field];

    if (value == null) {
      return '';
    }

    // console.log('Row Data: ' + JSON.stringify(rowData));

    if (rowData.Sales.toString().includes('%')) {
      if (value === "Gross Profit %:" || value === "% of Sales:") {
        return value
      }
      if (value == 0) {
        return '';
      }
      if (typeof value == 'number') {
        return `${value.toFixed(2)} %`;
      }
      return `${value}`;
      // return `${value.toFixed(2)} %`;
    }
    if (value == 0) {
      return '';
    }
    if (column.field === "Increase %") {
      return `${value.toFixed(2)} %`;

    }

    if (typeof value === 'number') {
      // Check if it's a percentage (ends with %)
      if (typeof value === 'string') {
        value = parseFloat(value);
      }
      if (value < 0) {
        return <div style={{ 
          color: 'red', 
          // backgroundColor: '#fcd9d9', 
          height: '36px', 
          paddingTop: "8px", 
          // border: '1px solid red' 
        }} > 
        
        {formatCurrency(value)}</div>
      }

      // Display the number with a $ sign and a maximum of two decimal places
      return formatCurrency(value);
    }

    return value;
  };
  const formatCurrency = (value) => {
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  };

  // Your component logic
  // const rowClass = (data) => {
  //   // Projects
  //   return {
  //     'bg-yellow-300': data['Sales'] === '2022 Projected Cash Flow Summary:' || data['Sales'] === '',
  //     'bg-gray-400': data['Sales'] === 'Revenue Projection' || data['Sales'] === 'Sales' || data['Sales'] === 'Projections and Assumption' ||data['Sales'] === 'Total' || data['Sales'] === 'Grand Total' || data['Sales'] === 'Total Projecs % of revenue',
  //     'bg-gray-200': data['Sales'] === 'POC' || data['Sales'] === 'OTHER' || data['Sales'] === 'POC & OTHER %',
  //   };
  // };

  const rowClass = (data) => {
    if (data['Sales'] === 'Revenue Projection' || data['Sales'] === 'Sales' || data['Sales'] === 'Projections and Assumption' || data['Sales'] === 'Total' || data['Sales'] === 'Grand Total' || data['Sales'] === 'Total Projects % of revenue') {
      return 'bg-gray-200';
    }
    return '';
  };

  const onCellEditComplete = async (e) => {
    const rowData = e.rowData;
    const newValue = e.newValue;
    const oldValue = e.value;
    const field = e.field || e.column?.props?.field;

    if (!isEditableGoalCell(rowData, field)) {
      return;
    }

    const parsedNewValue = coerceNumber(newValue);
    const parsedOldValue = coerceNumber(oldValue);
    if (parsedNewValue === parsedOldValue) {
      return;
    }

    const year = getYearFromColumn(field);
    const goalField = getGoalFieldFromRow(rowData);

    if (!year || !goalField) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Not editable',
        detail: 'This row cannot be saved as a goal value.'
      });
      return;
    }

    setProjectionSummary((prev) =>
      prev.map((row) => (row === rowData ? { ...row, [field]: parsedNewValue } : row))
    );

    try {
      const goalData = await fetchGoalForYear(year);
      const existingGoal = goalData?.result && typeof goalData.result === 'object' ? goalData.result : {};
      const payload = {
        ...goalDefaults,
        ...existingGoal,
        year,
        [goalField]: parsedNewValue
      };

      const saveResult = await saveGoalPayload(payload);
      if (saveResult?.error) {
        throw new Error(saveResult.error);
      }
      toast.current?.show({
        severity: 'success',
        summary: 'Saved',
        detail: `${field} updated successfully.`
      });
    } catch (error) {
      setProjectionSummary((prev) =>
        prev.map((row) => (row === rowData ? { ...row, [field]: parsedOldValue } : row))
      );
      toast.current?.show({
        severity: 'error',
        summary: 'Save failed',
        detail: error?.message || 'Unable to save this cell value.'
      });
    }
  };

  const cellEditor = (options, isFirstColumn) => {
    const field = options.field || options.column?.props?.field;
    if (isFirstColumn || !isEditableGoalCell(options.rowData, field)) {
      return null;
    }
    return (
      <InputText
        value={options.value ?? ''}
        onChange={(e) => options.editorCallback(e.target.value)}
        style={{ width: '100%' }}
      />
    );
  };

  // const renderTooltipCell = (rowData, column) => {
  //   const tooltipId = `tooltip-${(rowData.id || Math.random().toString(36).substr(2, 9))}`; // Ensures a valid ID
  
  //   return (
  //     <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
  //       <span>{rowData[column.field]}</span>
  //       <BsFillInfoCircleFill id={tooltipId} className='text-gray-500 hover:text-gray-900'  />
  //       <Tooltip 
  //         target={`#${tooltipId}`} 
  //         // content={rowData[column.field]} 
  //         content={rowData['Tooltip']} 
  //         position="top" 
  //         className="custom-tooltip"
  //       />
  //     </div>
  //   );

  // };

  const renderTooltipCell = (rowData, column) => {
    const tooltipId = `tooltip-${(rowData.id || Math.random().toString(36).substr(2, 9))}`; // Ensures a valid ID
    const hasTooltip = !!rowData['Tooltip']; // Check if there is a tooltip value
  
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <span>{rowData[column.field]}</span>
  
        {hasTooltip && (
          <>
            <BsFillInfoCircleFill
              id={tooltipId}
              className='text-gray-500 hover:text-gray-900'
            />
            <Tooltip
              target={`#${tooltipId}`}
              content={rowData['Tooltip']}
              position="top"
              className="custom-tooltip"
            />
          </>
        )}
      </div>
    );
  };
  

  return (
    <>
      <Toast ref={toast} />
      <div className=''>

        <div>
          {isLoading ? (
            <div className="loading-spinner">
              Loading...
              <div className="spinner"></div>
            </div>
          ) : (
            <div className="dataTableSummery p-2">
              {/* <DataTable
                value={projectionSummary}
                showGridlines
                headerColumnGroup={headerGroup}
                selectionMode="single"
                selection={selectedProduct}
                rowClassName={rowClass}
                onSelectionChange={(e) => setSelectedProduct(e.value)}
                tableStyle={{ tableLayout: 'fixed', minWidth: '90vw', minHeight: '500px', borderCollapse: 'separate', borderSpacing: '0', }}
                scrollable
                scrollHeight="flex"
                stripedRows
                size="small"
                className='financial-summary-datatble'
              >

                {ColumnName.map((row, i) => (
                  <Column
                    key={i}
                    field={row}
                    body={renderDecimalCell}


                    style={{ textAlign: i === 0 ? 'left' : 'center', borderRight: '1px solid gray', height: '27px', minWidth: '150px'}}
                    frozen={i === 0}
                  />

                ))}
              </DataTable> */}

              <DataTable
                value={projectionSummary}
                // showGridlines
                headerColumnGroup={headerGroup}
                rowClassName={rowClass}
                tableStyle={{ tableLayout: 'fixed', minWidth: '90vw', minHeight: '500px', borderCollapse: 'separate', borderSpacing: '0' }}
                scrollable
                scrollHeight="flex"
                // stripedRows
                size="small"
                className='financial-summary-datatble'
                editMode="cell"
              >
                {ColumnName.map((row, i) => (
                  i === 0 ? (
                    <Column
                      key={i}
                      field={row}
                      body={renderTooltipCell}
                      style={{ textAlign: 'left', height: '30px', minWidth: '100px' }}
                      frozen
                    />
                  ) : (
                    <Column
                      key={i}
                      field={row}
                      body={renderDecimalCell}
                      editor={(options) => cellEditor(options, false)}
                      onCellEditComplete={onCellEditComplete}
                      style={{ textAlign: 'center', height: '30px', minWidth: '100px' }}
                    />
                  )
                ))}
              </DataTable>
              
            </div>
          )}
        </div>
      </div>



    </>
  );
}

export default Summary;
